/* eslint-disable no-underscore-dangle */
/// <reference types="vite-plugin-svgr/client" />
import { PlaidAccountSubtypes, PlaidAccountTypes } from '@/types/plaid.types'

import CreditCardIcon from '@/assets/icons/cc.svg?react'
import ChairIcon from '@/assets/icons/chair.svg?react'
import CheckingIcon from '@/assets/icons/checking.svg?react'
import DebtIcon from '@/assets/icons/debt.svg?react'
import InvestmentsIcon from '@/assets/icons/invest.svg?react'
import OtherIcon from '@/assets/icons/other.svg?react'
import SavingIcon from '@/assets/icons/savings.svg?react'

export type AccountTypeItem = {
  label: string
  type: PlaidAccountTypes[]
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  subtype?: PlaidAccountSubtypes[]
}

export const ACCOUNT_TYPES: AccountTypeItem[] = [
  {
    icon: CheckingIcon,
    label: 'Checking',
    subtype: [PlaidAccountSubtypes.Checking],
    type: [PlaidAccountTypes.Depository],
  },
  {
    icon: SavingIcon,
    label: 'Savings',
    subtype: [
      PlaidAccountSubtypes.Savings,
      PlaidAccountSubtypes.MoneyMarket,
      PlaidAccountSubtypes.Cd,
      PlaidAccountSubtypes.Hsa,
      PlaidAccountSubtypes.CashIsa,
    ],
    type: [PlaidAccountTypes.Depository, PlaidAccountTypes.Investment],
  },
  {
    icon: CreditCardIcon,
    label: 'Credit Card',
    subtype: [PlaidAccountSubtypes.CreditCard, PlaidAccountSubtypes.Paypal],
    type: [PlaidAccountTypes.Credit],
  },
  {
    icon: ChairIcon,
    label: 'Retirement',
    subtype: [
      PlaidAccountSubtypes._401a,
      PlaidAccountSubtypes._401k,
      PlaidAccountSubtypes._403B,
      PlaidAccountSubtypes._457b,
      PlaidAccountSubtypes.Ira,
      PlaidAccountSubtypes.Roth,
      PlaidAccountSubtypes.Roth401k,
      PlaidAccountSubtypes.Keogh,
      PlaidAccountSubtypes.Pension,
      PlaidAccountSubtypes.ProfitSharingPlan,
      PlaidAccountSubtypes.Retirement,
      PlaidAccountSubtypes.Sarsep,
      PlaidAccountSubtypes.Sipp,
      PlaidAccountSubtypes.ThriftSavingsPlan,
      PlaidAccountSubtypes.Lif,
      PlaidAccountSubtypes.Lira,
      PlaidAccountSubtypes.Lrif,
      PlaidAccountSubtypes.Lrsp,
      PlaidAccountSubtypes.Prif,
      PlaidAccountSubtypes.Rdsp,
      PlaidAccountSubtypes.Rlif,
      PlaidAccountSubtypes.Rrif,
    ],
    type: [PlaidAccountTypes.Investment],
  },
  {
    icon: InvestmentsIcon,
    label: 'Investments',
    subtype: [
      PlaidAccountSubtypes._529,
      PlaidAccountSubtypes.Brokerage,
      PlaidAccountSubtypes.CryptoExchange,
      PlaidAccountSubtypes.EducationSavingsAccount,
      PlaidAccountSubtypes.FixedAnnuity,
      PlaidAccountSubtypes.Gic,
      PlaidAccountSubtypes.Hsa,
      PlaidAccountSubtypes.HealthReimbursementArrangement,
      PlaidAccountSubtypes.Isa,
      PlaidAccountSubtypes.NonCustodialWallet,
      PlaidAccountSubtypes.NonTaxableBrokerageAccount,
      PlaidAccountSubtypes.OtherAnnuity,
      PlaidAccountSubtypes.Other,
      PlaidAccountSubtypes.Resp,
      PlaidAccountSubtypes.StockPlan,
      PlaidAccountSubtypes.Tfsa,
      PlaidAccountSubtypes.Trust,
      PlaidAccountSubtypes.Ugma,
      PlaidAccountSubtypes.VariableAnnuity,
      PlaidAccountSubtypes.MutualFund,
      PlaidAccountSubtypes.CashManagement,
    ],
    type: [PlaidAccountTypes.Investment, PlaidAccountTypes.Depository],
  },
  {
    icon: DebtIcon,
    label: 'Debt',
    subtype: [
      PlaidAccountSubtypes.Auto,
      PlaidAccountSubtypes.Business,
      PlaidAccountSubtypes.Commercial,
      PlaidAccountSubtypes.Construction,
      PlaidAccountSubtypes.Consumer,
      PlaidAccountSubtypes.HomeEquity,
      PlaidAccountSubtypes.Loan,
      PlaidAccountSubtypes.Mortgage,
      PlaidAccountSubtypes.Overdraft,
      PlaidAccountSubtypes.LineOfCredit,
      PlaidAccountSubtypes.Student,
      PlaidAccountSubtypes.Other,
    ],
    type: [PlaidAccountTypes.Loan],
  },
  {
    icon: OtherIcon,
    label: 'Other',
    subtype: [
      PlaidAccountSubtypes.Ebt,
      PlaidAccountSubtypes.Prepaid,
      PlaidAccountSubtypes.Other,
      PlaidAccountSubtypes.LifeInsurance,
      PlaidAccountSubtypes.OtherInsurance,
    ],
    type: [PlaidAccountTypes.Depository, PlaidAccountTypes.Investment],
  },
]
